<template>
  <v-container grid-list-xl fluid>
    <confirm ref="confirm"></confirm>
    <v-snackbar :timeout="3000" bottom right :color="snackbar.color" v-model="snackbar.show">
      {{ snackbar.text }}
      <v-btn dark flat @click.native="snackbar.show = false" icon>
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>

    <!-- Header Card -->
    <v-card>
      <v-card-title>
        <span class="title">Tendencias de Precios - Convenio Marco</span>
        <v-spacer></v-spacer>
        <v-btn fab dark small color="primary" style="margin:0px" @click="cargarDatos()">
          <v-icon dark>refresh</v-icon>
        </v-btn>
      </v-card-title>
    </v-card>

    <!-- Filtros Card -->
    <v-card class="mt-3">
      <v-card-title>
        <span class="subheading">Filtros de Búsqueda</span>
      </v-card-title>
      <v-card-text>
        <v-layout row wrap>
          <!-- Rango de Fechas -->
          <v-flex xs12 sm6 md6>
            <date-range-picker @update:dateRange="handleDateRangeChange" />
          </v-flex>

          <!-- Región -->
          <v-flex xs12 sm6 md6>
            <v-select
              :items="filtrosDisponibles.regiones"
              v-model="filtros.regionMuestra"
              label="Región"
              clearable
              @change="cargarDatos()"
            ></v-select>
          </v-flex>
        </v-layout>

        <v-layout row wrap class="mt-2">
          <v-flex xs12 sm6>
            <v-btn color="green" dark @click="exportarExcel()" :loading="loadingExport">
              <v-icon left>attach_file</v-icon>
              Exportar Excel
            </v-btn>
          </v-flex>
          <v-flex xs12 sm6 class="text-xs-right">
            <v-chip color="info" text-color="white" v-if="resumen.totalRegistros">
              {{ resumen.totalRegistros }} registros | 
              {{ resumen.totalEmpresas }} empresas | 
              {{ resumen.totalRegiones }} región(es) |
              {{ tipoGraficoTexto }}
            </v-chip>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>

    <!-- 4 Gráficos Separados por Formato -->
    <v-layout row wrap class="mt-3">
      <v-flex xs12 sm6 class="pa-2">
        <v-card>
          <v-card-title class="pb-2">
            <span class="subheading">
              <v-icon left color="primary">whatshot</v-icon>
              Cilindros 5kg
            </span>
            <v-spacer></v-spacer>
            <v-chip small :color="tieneDatosFormato('5') ? 'success' : 'grey'" text-color="white">
              {{ contarRegistrosFormato('5') }} registros
            </v-chip>
          </v-card-title>
          <v-card-text class="pt-0" style="height: 300px;">
            <line-tendencias
              :datos-grafico="datosGrafico"
              :formato="'5'"
              :es-un-solo-dia="esUnSoloDia"
            />
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12 sm6 class="pa-2">
        <v-card>
          <v-card-title class="pb-2">
            <span class="subheading">
              <v-icon left color="primary">whatshot</v-icon>
              Cilindros 11kg
            </span>
            <v-spacer></v-spacer>
            <v-chip small :color="tieneDatosFormato('11') ? 'success' : 'grey'" text-color="white">
              {{ contarRegistrosFormato('11') }} registros
            </v-chip>
          </v-card-title>
          <v-card-text class="pt-0" style="height: 300px;">
            <line-tendencias
              :datos-grafico="datosGrafico"
              :formato="'11'"
              :es-un-solo-dia="esUnSoloDia"
            />
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12 sm6 class="pa-2">
        <v-card>
          <v-card-title class="pb-2">
            <span class="subheading">
              <v-icon left color="primary">whatshot</v-icon>
              Cilindros 15kg
            </span>
            <v-spacer></v-spacer>
            <v-chip small :color="tieneDatosFormato('15') ? 'success' : 'grey'" text-color="white">
              {{ contarRegistrosFormato('15') }} registros
            </v-chip>
          </v-card-title>
          <v-card-text class="pt-0" style="height: 300px;">
            <line-tendencias
              :datos-grafico="datosGrafico"
              :formato="'15'"
              :es-un-solo-dia="esUnSoloDia"
            />
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12 sm6 class="pa-2">
        <v-card>
          <v-card-title class="pb-2">
            <span class="subheading">
              <v-icon left color="primary">whatshot</v-icon>
              Cilindros 45kg
            </span>
            <v-spacer></v-spacer>
            <v-chip small :color="tieneDatosFormato('45') ? 'success' : 'grey'" text-color="white">
              {{ contarRegistrosFormato('45') }} registros
            </v-chip>
          </v-card-title>
          <v-card-text class="pt-0" style="height: 300px;">
            <line-tendencias
              :datos-grafico="datosGrafico"
              :formato="'45'"
              :es-un-solo-dia="esUnSoloDia"
            />
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <loader :value="loading" message="Cargando datos de tendencias" progressColor="blue"></loader>
  </v-container>
</template>

<script>
import TendenciasService from "@/services/TendenciasService";
import DateRangePicker from "@/components/DateRangePicker";
import LineTendencias from "@/components/lineTendencias";
import Loader from "@/components/Loader";
import moment from "moment";

export default {
  components: {
    DateRangePicker,
    LineTendencias,
    Loader
  },
  data: () => ({
    snackbar: {
      show: false,
      text: "",
      color: ""
    },
    loading: false,
    loadingGrafico: false,
    loadingExport: false,
    busquedaTabla: "",
    mostrarTabla: false,
    
    // Datos de la API
    datosRaw: [],
    datosGrafico: [],
    filtrosDisponibles: {
      regiones: [],
      formatos: [],
      empresas: [],
      regionesCompletas: []
    },
    resumen: {
      totalRegistros: 0,
      fechaInicio: null,
      fechaFin: null,
      totalEmpresas: 0,
      totalRegiones: 0,
      totalFormatos: 0
    },

    // Filtros del usuario
    filtros: {
      fechaInicio: null,
      fechaFin: null,
      regionMuestra: null
    },

    // Formatos principales que siempre se muestran
    formatosPrincipales: ['5', '11', '15', '45']
  }),

  computed: {
    esUnSoloDia() {
      // Solo es un solo día cuando:
      // 1. Ambas fechas están seleccionadas
      // 2. Y son exactamente el mismo día
      if (this.filtros.fechaInicio && this.filtros.fechaFin) {
        return this.filtros.fechaInicio === this.filtros.fechaFin;
      }
      
      // Si no hay fechas seleccionadas o solo una, mostrar gráfico de líneas
      return false;
    },

    tipoGraficoTexto() {
      return this.esUnSoloDia ? "Gráfico de Barras" : "Gráfico de Líneas";
    }
  },

  methods: {
    handleDateRangeChange({ start, end }) {
      this.filtros.fechaInicio = start;
      this.filtros.fechaFin = end;
      if (end !== null) {
        this.cargarDatos();
      }
    },

    async cargarDatos() {
      this.loading = true;
      this.loadingGrafico = true;

      try {
        const params = this.construirParametros();
        console.log('Parámetros enviados:', params);
        
        const response = await TendenciasService.getTendenciasProductos(params);
        
        console.log('Respuesta completa:', response.data);
        console.log('Datos raw:', (response.data.datosRaw && response.data.datosRaw.length) || 0);
        console.log('Datos gráfico:', (response.data.datosGrafico && response.data.datosGrafico.length) || 0);
        console.log('Filtros disponibles:', response.data.filtrosDisponibles);
        
        this.datosRaw = response.data.datosRaw || [];
        this.datosGrafico = response.data.datosGrafico || [];
        this.filtrosDisponibles = response.data.filtrosDisponibles || {};
        this.resumen = response.data.resumen || {};

        console.log('Formatos en datos:', this.datosGrafico.map(d => d.formato));

        this.snackbar = {
          show: true,
          color: 'success',
          text: `Datos cargados: ${this.resumen.totalRegistros} registros`
        };

      } catch (error) {
        console.error('Error cargando tendencias:', error);
        this.snackbar = {
          show: true,
          color: 'error',
          text: 'Error al cargar los datos de tendencias'
        };
      } finally {
        this.loading = false;
        this.loadingGrafico = false;
      }
    },

    async exportarExcel() {
      this.loadingExport = true;
      try {
        const params = this.construirParametros();
        await TendenciasService.exportarTendenciasExcel(params);
        
        this.snackbar = {
          show: true,
          color: 'success',
          text: 'Archivo Excel descargado exitosamente'
        };
      } catch (error) {
        console.error('Error exportando Excel:', error);
        this.snackbar = {
          show: true,
          color: 'error',
          text: 'Error al exportar el archivo Excel'
        };
      } finally {
        this.loadingExport = false;
      }
    },

    construirParametros() {
      const params = {};
      if (this.filtros.fechaInicio) params.fechaInicio = this.filtros.fechaInicio;
      if (this.filtros.fechaFin) params.fechaFin = this.filtros.fechaFin;
      if (this.filtros.regionMuestra) params.regionMuestra = this.filtros.regionMuestra;
      return params;
    },

    tieneDatosFormato(formato) {
      return this.datosGrafico.some(serie => serie.formato === formato);
    },

    contarRegistrosFormato(formato) {
      return this.datosRaw.filter(item => item.formato === formato).length;
    },

    formatDate(date) {
      if (!date) return '';
      return moment(date).format("DD-MM-YYYY HH:mm");
    },

    formatPrice(value) {
      if (!value) return '';
      return '$' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },

    getColorByPosition(orden) {
      const colores = {
        1: 'green',
        2: 'orange', 
        3: 'red'
      };
      return colores[orden] || 'grey';
    }
  },

  async mounted() {
    await this.cargarDatos();
  }
};
</script>

<style>
.v-progress-circular {
  display: block;
  width: 100px;
  margin: 0 auto;
}

.truncate-text {
  max-width: 300px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>